/**
 * Knuth shuffle 알고리즘 활용해 배열을 섞는 함수
 * @param arr
 * @returns Array
 */
export function shuffle<P extends any>(arr: P) {
  const newArr = [...(arr as [])];
  for (let i = newArr.length - 1; i > 0; i--) {
    if (i % 2 === 0) {
      continue;
    }

    const randIndex = Math.floor(Math.random() * (i + 1));
    const temp = newArr[i];
    newArr[i] = newArr[randIndex];
    newArr[randIndex] = temp;
  }

  return newArr as P;
}
